__turbopack_context__.v({
  "bannerContainer": "SpecialOfferBanner-module__sUUZiW__bannerContainer",
  "offer": "SpecialOfferBanner-module__sUUZiW__offer",
  "offerContent": "SpecialOfferBanner-module__sUUZiW__offerContent",
  "offerDescription": "SpecialOfferBanner-module__sUUZiW__offerDescription",
  "offerTitle": "SpecialOfferBanner-module__sUUZiW__offerTitle",
  "offersImageContainer": "SpecialOfferBanner-module__sUUZiW__offersImageContainer",
  "pulse": "SpecialOfferBanner-module__sUUZiW__pulse",
  "slideIn": "SpecialOfferBanner-module__sUUZiW__slideIn",
});
